var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTurbineYellowTips = function SvgTurbineYellowTips(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 165,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M56.239 165c23.159 0 41.933-3.129 41.933-6.989s-18.774-6.989-41.933-6.989c-23.16 0-41.934 3.13-41.934 6.989S33.079 165 56.239 165",
    opacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m63.508 157.942-7.14-85.224H52.63l-3.427 85.224s4.213 1.366 14.305 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M55.164 64.54s47.199 35.645 54.096 34.37c6.896-1.274-36.66-34.927-36.66-34.927s-13.037-2.132-17.436.557M52.716 65.565S1.761 95.86.357 102.638c-1.403 6.779 46.01-20.75 46.01-20.75s7.154-11.205 6.349-16.323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA200",
    d: "M17.017 97.72 13.59 90.6a118 118 0 0 0-9.687 7.598l2.405 4.322c2.949-1.137 6.67-2.844 10.708-4.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M54.698 64.373S60.264 5.617 55.838.357 45.625 49.673 45.625 49.673s4.69 12.311 9.072 14.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA200",
    d: "m50.395 16.535 7.114 1.346c.1-3.78.003-7.563-.292-11.332L52.71 5.96c-.709 2.796-1.585 6.518-2.315 10.575"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M56.555 57.224h-3.373a4.6 4.6 0 0 0-1.803.293 4.7 4.7 0 0 0-1.557.975A4.8 4.8 0 0 0 48.75 60c-.257.57-.401 1.186-.424 1.813v2.456l-.315 10.832 12.748-1.17.36-9.18v-2.456c.03-.64-.065-1.28-.278-1.881a4.9 4.9 0 0 0-.967-1.627 4.75 4.75 0 0 0-1.507-1.121 4.7 4.7 0 0 0-1.812-.443"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.97 69.142a3.576 3.576 0 1 0 .001-7.153 3.576 3.576 0 0 0 0 7.153"
  })));
};
export default SvgTurbineYellowTips;